const Feature = {
    FocusableContent: 'focusable-content',
    Contextual: 'contextual',
    TriggerInGlobalNavigation: 'trigger-in-global-navigation',
    NoOuterRightTriggerLimitation: 'no-outer-right-trigger-limitation',
    FormElements: 'form-elements',
    DeepLinking: 'deep-linking',
    Searching: 'searching',
}

export default Feature
